import filters from '../store';

/**
 * @param {MouseEvent|KeyboardEvent} e
 * @param {String} filterKey
 * @param {String} filterValue
 */
export default function removeLocation(e, filterKey, filterValue) {
	e.preventDefault();
	e.stopPropagation();

	filters.update((/** @type {Object<String, any>} */store) => ({
		...store,
		[filterKey]: store[filterKey].filter((/** @type {String} */x) => !x?.includes(filterValue))
	}));
}
